<template>
  <section v-if="getShowBillingCampaign" class="wrapper-campaign">
    <header>
      <h1>Campanha de Discagem Cold Lead</h1>
    </header>

    <div class="scheduled-clients-button">
      <button class="btn btn-info scheduled-btn" @click="showScheduledClients"><i class="fa-solid fa-calendar-day"
          style="font-size: 15px;"></i>
        Agenda
      </button>
    </div>

    <div v-if="validateClients" class="wrapper-clients-info">
      <div v-if="showCurrentClient" :class="[
        'client-info',
        'current-client',
        (showCurrentClient.redial || showCurrentClient.schedule_date || showCurrentClient.tab == 7) && 'redial-client',
        (showCurrentClient.tab && !showCurrentClient.redial && !showCurrentClient.schedule_date && showCurrentClient.tab != 7) && 'tabulated-client',
        (!showCurrentClient.tab && !showCurrentClient.redial && !showCurrentClient.schedule_date) && 'new-client'
      ]">
        <h1>Cliente Atual</h1>
        <span><b>Empresa: </b> {{ showCurrentClient.company_name }}</span>
        <span><b>Cliente: </b> {{ showCurrentClient.client_name }}</span>
        <span><b>Telefone: </b>{{ showCurrentClient.client_phone }}</span>
        <span><b>WhatsApp: </b>{{ showCurrentClient.whatsapp }}</span>
        <span><b>Segmento </b>{{ showCurrentClient.segmento }}</span>

        <span v-if="showCurrentClient.redial || (showCurrentClient.redial_count && showCurrentClient.redial_count > 1)">
          <b>Tentativa: </b>
          {{ showCurrentClient.redial_count }} de 3

          <span v-if="['Caixa Postal', 'Fone Mudo / Fone Indisponivel'].includes(showCurrentClient.reason)">
            ({{ showCurrentClient.reason }})
          </span>
          <span v-else>(Rediscagens anteriores)</span>
        </span>


        <span v-if="showCurrentClient.tab">
          <b>Tabulação: </b>{{ convertTabOption(showCurrentClient.tab) }}
        </span>
        <span v-if="showCurrentClient.tab">
          <b>Razâo: </b>{{ showCurrentClient.reason }}
        </span>
        <span v-if="showCurrentClient.tab">
          <b>Descrição: </b>
          {{ showCurrentClient.tab_obs }}
          <span v-if="showCurrentClient.tab === 7"> ({{ showCurrentClient.user_name }})</span>
        </span>

        <div class="wrapper-dial-now">
          <button class="btn" :class="{ 'btn-primary': isDialEnabled, 'btn-secondary': !isDialEnabled }"
            @click="dialCurrentClient" :disabled="!isDialEnabled">
            <span>Discar para {{ showCurrentClient.client_name }}</span>
            <i class="fas fa-phone"></i>
          </button>
        </div>
      </div>
    </div>

    <div v-else class="wrapper-no-clients">
      <h1>Sem Clientes</h1>
      <i class="fas fa-ban"></i>
    </div>

    <hr>

    <div v-if="validateClients" class="wrapper-timer">
      <section>
        <div class="clock-wrap">
          <div class="clock pro-0">
            <span class="count">{{ count }}</span>
          </div>
        </div>
      </section>
    </div>

  </section>
</template>


<script>
const socketAMI = io.connect(`${location.protocol}//${location.hostname}:3002/`);
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "BillingDialCampaign",
  data() {
    return {
      campaignTimer: 10,
      campaignClientsBilling: [],
      countdown: true,
      tabOptions: [],
      timeBetweenCampaigns: false,
      interval: null,
      half: 0,
      barColor: "#00b4d8",
      backColor: "#feeff4",
      count: 0,
      inCall: false,
      isDialEnabled: false,
      isUpdatingCampaign: false,
      isUpdatingClient: false,
    };
  },
  methods: {
    ...mapActions([
      "setCallData",
    ]),
    dialCurrentClient() {
      if (this.inCall || !this.isDialEnabled) return;
      if (this.validateClients) {
        const clientPhone = this.formatPhoneToCall(this.campaignClientsBilling[0].client_phone);
        socketAMI.emit('OriginateTab', {
          calltype: 'outgoing',
          extension: user.getExtension(),
          phone: `0${clientPhone}`,
        });
      }
    },

    async showScheduledClients() {
      await this.checkClients();
      const check = this.clients;
      let notifiedSwal = false;

      // Ordena os clientes pelo horário
      if (check) {
        check.sort((a, b) => moment(a.schedule_date).unix() - moment(b.schedule_date).unix());
      }

      // Filtra apenas clientes agendados nas próximas 1h
      const upcomingSchedules = check
        .filter(client => {
          const scheduleTime = moment(client.schedule_date);
          const now = moment();
          const diffInMinutes = scheduleTime.diff(now, "minutes");

          return (
            diffInMinutes <= 60 &&
            diffInMinutes >= 0 &&
            (
              client.scheduled_to === null ||                      // sem consultor
              Number(client.scheduled_to) === Number(user.getId()) // atribuído ao operador logado
            )
          );
        })
        .map(client => ({
          clientName: client.client_name,
          time: moment(client.schedule_date).format("HH:mm"),
          // evita mostrar "null", sempre mostra um texto válido
          consultant: client.scheduled_name && client.scheduled_name.trim() !== ""
            ? client.scheduled_name
            : "Livre"
        }));

      // Monta a lista de clientes
      let scheduleListHTML = `
    <div style="display: flex; flex-direction: column; gap: 10px; padding: 5px;">
  `;

      upcomingSchedules.forEach(schedule => {
        scheduleListHTML += `
      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #ffffff;
        padding: 12px 14px;
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.08);
        font-size: 14px;
        transition: background 0.2s, box-shadow 0.2s;
      " 
      onmouseover="this.style.background='#f9f9f9'; this.style.boxShadow='0 3px 6px rgba(0,0,0,0.12)';" 
      onmouseout="this.style.background='#ffffff'; this.style.boxShadow='0 1px 4px rgba(0,0,0,0.08)';">
        
        <!-- Coluna esquerda: Nome + Consultor -->
        <div style="display: flex; flex-direction: column; text-align: left;">
          <strong style="color: #1a6fa5; font-size: 15px;">${schedule.clientName}</strong>
          <span style="color: #7f8c8d; font-size: 13px; display: flex; align-items: center; gap: 5px;">
            <i class="fas fa-user" style="color:#16a085;"></i>
            ${schedule.consultant}
          </span>
        </div>

        <!-- Coluna direita: Horário -->
        <div style="display: flex; align-items: center; gap: 5px; color: #16a085; font-weight: bold; font-size: 14px;">
          <i class="fas fa-clock"></i> ${schedule.time}
        </div>
      </div>
    `;
      });

      scheduleListHTML += "</div>";

      // Exibe o modal
      Swal.fire({
        toast: true,
        position: "top-end",
        html: `
      <div style="font-family: 'Arial', sans-serif; max-width: 320px; text-align: center;">
        
        <!-- Cabeçalho com ícone -->
        <div style="display: flex; justify-content: center; align-items: center; 
                    background-color: ${upcomingSchedules.length > 0 ? "#16a085" : "#e74c3c"}; 
                    border-radius: 50%; width: 50px; height: 50px; 
                    margin: 0 auto; color: #fff;">
          <i class="fas ${upcomingSchedules.length > 0 ? "fa-calendar-check" : "fa-calendar-xmark"}" style="font-size: 24px;"></i>
        </div>

        <!-- Título -->
        <h3 style="color: #2c3e50; margin: 15px 0 10px 0; font-size: 16px; font-weight: bold;">
          ${upcomingSchedules.length > 0 ? "Clientes Agendados!" : "Sem Clientes Agendados"}
        </h3>

        <!-- Lista -->
        <div style="max-height: 200px; overflow-y: auto; padding-right: 5px; text-align:left;">
          ${upcomingSchedules.length > 0
            ? scheduleListHTML
            : "<p style='color: #555; font-size: 14px; text-align:center;'>Sem clientes agendados em até 1 hora.</p>"}
        </div>

        <!-- Rodapé -->
        ${upcomingSchedules.length > 0
            ? `<p style="color: #555; font-size: 14px; margin-top: 10px; text-align:center;">
              Existem <strong style="color: #e74c3c;">${upcomingSchedules.length}</strong> clientes agendados em até 1 hora.
            </p>`
            : ""}
      </div>
    `,
        showCloseButton: true,
        showConfirmButton: false,
        background: "#ecf0f1",
        customClass: { popup: "animated fadeInDown" }
      });

      notifiedSwal = true;
      setTimeout(() => (notifiedSwal = false), 300000); // 5 minutos
    },

    async startFromHangup() {
      this.inCall = false;
      await this.updateClient(this.campaignClientsBilling[0], this.getCallData);
      this.getCallData.tab_obs = null;
      this.getClients();
      this.startCountdown();
    },

    async delaySendingCall(ms = 1000) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },

    async deactivateCampaignAndSetDefault() {
      const response = await axios.post('/desactivateCampaignBilling');

      if (response.data.success) {
        const deactivatedCampaign = response.data.deactivated_campaign;
        Swal.fire({
          html: `
          <div style="text-align: center; font-family: 'Arial', sans-serif; color: #333;">
            <img src="/imgs/calendar.gif" alt="Timer" style="margin-bottom: 5px; max-width: 125px; display: block; margin: 0 auto;"/>
            <hr>
            <p style="font-size: 1.5em; font-weight: bold; color: #D32F2F; margin: 15px 0;">
              <span style="font-style: italic;">${deactivatedCampaign}</span>
            </p>
            <p style="font-size: 1.05em; margin: 5px 0; line-height: 1.3;">
              A campanha foi desativada por exceder os 30 dias limites de ativação.
            </p>
            <p style="font-size: 0.85em; color: #555;">Se precisar de mais informações, entre em contato com o suporte.</p>
          </div>`,
          showConfirmButton: true,
          confirmButtonText: '<i class="fa-regular fa-circle-check"></i>',
          confirmButtonColor: '#4CAF50',
          allowOutsideClick: false,
          footer: `
          <div style="text-align: center;">
            <span style="font-size: 0.75em; color: #AAA;">Obrigado por usar nosso sistema!</span><br/>
            <span style="font-size: 0.75em; color: #AAA;">Powered by <strong>Advance</strong></span>
            <img src="imgs/advance-logo.png" alt="Logo da Advance" style="max-width: 20px; margin-left: 5px; vertical-align: middle;" />
          </div>`,
          customClass: {
            popup: 'animated bounceIn',
          },
          backdrop: `rgba(0, 0, 0, 0.4) 
                      left top
                      no-repeat`,
          onBeforeOpen: () => {
            const confirmButton = Swal.getConfirmButton();
            confirmButton.setAttribute("style", `
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            margin: -15px; 
            border-radius: 30px !important; 
            background-color: #4CAF50 !important; 
            color: white; 
            width: 50px; 
            height: 50px;
            display: flex; 
            justify-content: center; 
            align-items: center;
            font-size: 24px;`);
          }
        });
        sessionStorage.removeItem("campaignClientBilling");
      }
    },

    // Função que busca clientes agendados ou campanhas
    async getClients() {
      if (this.isUpdatingCampaign) return;
      this.isUpdatingCampaign = true;

      try {
        await this.deactivateCampaignAndSetDefault();

        const clientSession = sessionStorage.getItem("campaignClientBilling");
        const existingClientInSession = clientSession ? JSON.parse(clientSession) : null;
        let clientToUse = null;

        const now = moment();

        // 1️⃣ Clientes em atendimento com o operador
        const { data: clientsInAttendance } = await axios.get("/getClientsInAttendance");

        const inProgressClient = clientsInAttendance.find(
          c => c.user_id == user.getId() && c.call_status === "em_atendimento"
        );

        if (inProgressClient) {
          clientToUse = inProgressClient;
          this.campaignClientsBilling = [inProgressClient];
          sessionStorage.setItem("campaignClientBilling", JSON.stringify(clientToUse));
          return;
        }

        // 2️⃣ Clientes agendados
        let scheduledClients = await axios
          .get("/generateBillingCampaignScheduledAndLock")
          .then(({ data }) => (Array.isArray(data) ? data : data ? [data] : []));

        scheduledClients = scheduledClients.filter(
          c => c.scheduled_to === null || c.scheduled_to == user.getId()
        );

        if (scheduledClients.length > 0) {
          // separa agendados para agora e os antigos
          const currentSchedules = scheduledClients.filter(c =>
            moment(c.schedule_date).isSameOrBefore(now)
          );

          const pastSchedules = scheduledClients
            .filter(c => moment(c.schedule_date).isBefore(now))
            .sort((a, b) => moment(a.schedule_date).diff(moment(b.schedule_date)));

          if (currentSchedules.length > 0) {
            // prioridade: agendados para o horário atual
            clientToUse = currentSchedules[0];
            this.campaignClientsBilling = currentSchedules;
            sessionStorage.setItem("campaignClientBilling", JSON.stringify(clientToUse));
            return;
          } else if (pastSchedules.length > 0) {
            // depois: agendados mais antigos
            clientToUse = pastSchedules[0];
            this.campaignClientsBilling = pastSchedules;
            sessionStorage.setItem("campaignClientBilling", JSON.stringify(clientToUse));
            return;
          }
        }

        // 3️⃣ Clientes recusados
        let refusedClients = [];
        try {
          const { data } = await axios.get("/generateBillingCampaignRefused");
          refusedClients = data || [];
        } catch (err) {
          console.error("Erro ao buscar clientes recusados:", err);
        }

        if (refusedClients.length > 0) {
          clientToUse =
            existingClientInSession &&
              refusedClients.find(c => c.id === existingClientInSession.id)
              ? existingClientInSession
              : refusedClients[0];

          this.campaignClientsBilling = refusedClients;
          sessionStorage.setItem("campaignClientBilling", JSON.stringify(clientToUse));
          return;
        }

        // 4️⃣ Novos clientes + rediscagem
        const normalClients = clientsInAttendance.filter(
          c => !c.call_id && c.call_status === "nao_atendido"
        );

        const redialClients = clientsInAttendance
          .filter(c => c.redial === 1 && c.redial_count > 0)
          .sort((a, b) => a.redial_count - b.redial_count);

        const finalClients = [...normalClients, ...redialClients];

        if (finalClients.length > 0) {
          clientToUse =
            existingClientInSession &&
              finalClients.find(c => c.id === existingClientInSession.id)
              ? existingClientInSession
              : finalClients[0];

          this.campaignClientsBilling = finalClients;
          sessionStorage.setItem("campaignClientBilling", JSON.stringify(clientToUse));
          return;
        }

        // 5️⃣ Fallback: clientes padrão
        const { data: defaultClients } = await axios.get("/generateBillingCampaign");
        const orderedDefaultClients = defaultClients.sort(
          (a, b) => a.redial_count - b.redial_count
        );

        if (orderedDefaultClients.length > 0) {
          clientToUse = existingClientInSession || orderedDefaultClients[0];
          this.campaignClientsBilling = orderedDefaultClients;
          sessionStorage.setItem("campaignClientBilling", JSON.stringify(clientToUse));
        } else {
          clientToUse = null;
          this.campaignClientsBilling = [];
          sessionStorage.removeItem("campaignClientBilling");
        }
      } catch (error) {
        console.error("Erro ao obter clientes:", error);
        this.campaignClientsBilling = [];
        sessionStorage.removeItem("campaignClientBilling");
      } finally {
        this.isUpdatingCampaign = false;
      }
    },

    startClientCheckInterval() {
      this.clientCheckInterval = setInterval(() => {
        if (!sessionStorage.getItem("campaignClientBilling")) {
          this.getClients();
          this.startCountdown();
        }
      }, 10000);
    },

    stopClientCheckInterval() {
      if (this.clientCheckInterval) {
        clearInterval(this.clientCheckInterval);
      }
    },

    getTabOptions() {
      axios.get("/listTabOptions")
        .then(({ data }) => {
          this.tabOptions = data;
        });
    },

    async checkClients() {
      try {
        const { data } = await axios.get("/getScheduledCallsColdLead");

        const clients = Array.isArray(data) ? data : (data ? [data] : []);

        this.clients = clients.filter(client =>
          client.scheduled_to === null || Number(client.scheduled_to) === Number(user.getId())
        );

      } catch (error) {
        console.error("Erro ao buscar clientes agendados:", error);
        this.clients = [];
      }
    },

    async updateClient(client, callData) {
      const recalCase = { 13: true, 15: true };

      client.user_id = callData.user_id || null;
      client.call_id = callData.call_id || null;
      client.tab = callData.tab || null;
      client.reason = callData.reason || null;
      client.tab_obs = callData.tab_obs || null;
      client.schedule_date = callData.scheduling_datetime || null;
      client.user_name = callData.user_name || null;
      client.user_phone = callData.user_phone || null;
      client.scheduled_name = callData.scheduled_name || null;
      client.extension_scheduled = callData.extension_scheduled || null;

      // 🔹 scheduled_to só vai junto quando for reason = 3
      client.scheduled_to = (Number(callData.tab_reason_id) === 3) ? (callData.scheduled_to || null) : null;

      if ([2, 3, 11, 16, 17].includes(Number(callData.tab_reason_id))) {
        if (!client.tab_obs) {
          client.tab_obs = "Agendamento: " + moment(callData.scheduling_datetime).format("DD/MM/YYYY HH:mm:ss");
        }
        client.schedule_check = 1;
      } else {
        client.schedule_check = 1;
        client.schedule_date = null;
        callData.scheduling_datetime = null;
      }

      if (recalCase[callData.tab_reason_id]) {
        if (client.redial_count) {
          client.redial_count += 1;
        } else {
          client.redial_count = 1;
        }
        client.redial = true;

        const redial_date = moment().startOf('day').format('YYYY-MM-DD');

        if (client.redial_count >= 3) {
          client.tab_obs = "Limite de rediscagem atingido, não foi possivel contactar o cliente!";
          client.redial = false;
          client.last_redial_date = redial_date;
          client.last_user_id = null;
        }
      } else {
        client.redial = false;
      }

      // 4️⃣ Salva no back-end
      return await axios.put("updateBillingCampaign", client)
        .then(({ data }) => {
          sessionStorage.removeItem("campaignClientBilling");
          this.setCallData({
            call_id: null,
            tab: null,
            tab_obs: null,
            scheduling_datetime: null,
          });
        });
    },

    listeningCalls() {
      socketAMI.on(`CoreShowChannel-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });

      socketAMI.on(`NewConnectedLine-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });
    },
    listeningHangupRinging() {
      socketAMI.on(`HangupRinging-${user.getExtension()}`, async () => {
        if (this.isUpdatingClient) return;
        this.isUpdatingClient = true;
        const callData = {
          call_id: null,
          tab: 7,
          tab_obs: "Discagem recusada pelo operador",
        };

        this.inCall = false;

        if (this.campaignClientsBilling.length > 0) {
          try {
            await this.updateClient(this.campaignClientsBilling[0], callData);
            await this.getClients();
          } catch (error) {
            console.error("Erro ao atualizar o cliente:", error);
          } finally {
            this.isUpdatingClient = false;
          }
          this.startCountdown();
        } else {
          this.stopCountdown();
          this.isUpdatingClient = false;
        }
      });
    },
    formatPhoneToCall(phone) {
      let newPhone = phone.replace(/\D/g, "");
      newPhone = newPhone.slice(0, 2) == "55" ? newPhone.slice(2) : newPhone;
      return newPhone;
    },
    formatMoney(value) {
      if (value === null || value === undefined) return '';

      const numericValue = value.toString().replace(/[^\d.,]/g, '');

      const cleanedValue = numericValue.replace(',', '.');

      const floatValue = parseFloat(cleanedValue);

      if (isNaN(floatValue)) return '';
      return floatValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    formatCpfCnpj(value) {
      const cnpjCpf = value?.replace(/\D/g, '');
      if (cnpjCpf?.length === 11) {
        return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
      }

      return cnpjCpf?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
    },
    convertTabOption(option) {
      return this.tabOptions[option] || "";
    },
    async startCountdown() {
      this.clearCountdown();
      let pie = 0;
      let num = 0;
      let sec = 15;
      let lop = sec;
      this.count = sec;
      this.isDialEnabled = false;
      $(".count").addClass("sec");

      this.interval = setInterval(() => {
        sec = sec - 1;
        pie = pie + 100 / lop;

        if (pie >= 101) {
          pie = 1;
        }

        num = (sec / 60).toFixed(2).slice(0, -3);
        if (num == 0) {
          $(".count").removeClass("min").addClass("sec");
          this.count = sec;
        } else {
          $(".count").removeClass("sec").addClass("min");
          this.count = num;
        }

        let indx = pie.toFixed(2).slice(0, -3) - 1;
        if (indx < this.half) {
          let nextdeg = 90 + this.increment * indx + "deg";
          $(".clock").css({
            "background-image": "linear-gradient(90deg," + this.backColor + " 50%,transparent 50%,transparent),linear-gradient(" + nextdeg + "," + this.barColor + " 50%," + this.backColor + " 50%," + this.backColor + ")",
          });
        } else {
          let nextdeg = -90 + this.increment * (indx - this.half) + "deg";
          $(".clock").css({
            "background-image": "linear-gradient(" + nextdeg + "," + this.barColor + " 50%,transparent 50%,transparent),linear-gradient(270deg," + this.barColor + " 50%," + this.backColor + " 50%," + this.backColor + ")",
          });
        }

        if (sec == 0) {
          this.stopCountdown();
        }
      }, 1000);

      setTimeout(() => {
        this.isDialEnabled = true;
      }, 2000);
    },
    stopCountdown() {
      this.clearCountdown();
      this.dialCurrentClient();
      this.countdown = false;
    },
    clearCountdown() {
      clearInterval(this.interval);
      this.count = 0;
      $(".clock").removeAttr("style");
    },
    saveClientOnCookie() {
      if (this.validateClients) {
        window.document.cookie = JSON.stringify(this.campaignClientsBilling[0]);
      } else {
        window.document.cookie = "";
      }
    },

    async maxRedialClients() {
      try {
        const { data } = await axios.get("/maxRedialAttemptBilling");
        const today = moment().startOf("day").unix();

        const clientsToReset = data.filter(client => {
          const lastRedialDate = moment(client.last_redial_date).startOf("day").unix();

          // Aplicando os filtros
          return today > lastRedialDate &&
            client.active === 1 &&
            client.redial === 0 &&
            client.redial_count >= 3;
        });

        if (!clientsToReset.length) return;

        await axios.post("/resetRedialBatchBilling", { clients: clientsToReset });

        console.log(`Reset diário feito para ${clientsToReset.length} clientes`);
      } catch {
        // erro silencioso
      }
    },

  },
  async beforeMount() {
    this.getClients();
    this.getTabOptions();
    this.listeningHangupRinging();
    this.listeningCalls();
    this.maxRedialClients();
  },

  mounted() {
    const step = 1;
    const loops = Math.round(100 / step);
    this.increment = 360 / loops;
    this.half = Math.round(loops / 2);
    this.barColor = "#00b4d8";
    this.backColor = "#feeff4";

    if (this.getShowBillingCampaign && !this.inCall) {
      this.startCountdown();
    }
    this.startClientCheckInterval();
  },
  beforeDestroy() {
    this.clearCountdown();
    this.stopClientCheckInterval();
  },
  computed: {
    ...mapGetters([
      "getShowBillingCampaign",
      "getStartCampaign",
      "getCallData",
    ]),
    validateClients() {
      return this.campaignClientsBilling.length > 0;
    },
    showCurrentClient() {
      return this.campaignClientsBilling[0] || false;
    },
  },
  watch: {
    getStartCampaign() {
      this.startFromHangup();
    },
    getShowBillingCampaign() {
      if (this.getShowBillingCampaign && !this.inCall) {
        this.startCountdown();
      }
    }
  },
};
</script>

<style scoped>
.tabulated-client {
  background-color: #d4edda;
  /* Cor de fundo verde clara */
  border-color: #c3e6cb;
  /* Bordas mais suaves */
}

.btn-confirm {
  border-radius: 30px !important;
}

.custom-confirm-button {
  border-radius: 8px !important;
  margin: -15px;
}

.btn-secondary {
  background-color: gray;
  /* Cor cinza para o botão desativado */
  color: white;
  /* Cor do texto */
  cursor: not-allowed;
  /* Mudar o cursor para indicar que está desativado */
}


.scheduled-clients-button {
  position: absolute;
  right: 0;
  top: 0;
  margin: 45px;
}

.scheduled-btn {
  background-color: #007bff;
  color: white;
  border-radius: 20px !important;
  margin: 0;
  padding: 10px 30px;
  font-weight: bold;
  font-size: 13px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: background-color 0.3s, transform 0.2s;
  border: none;
}

.scheduled-btn:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}



.wrapper-campaign {
  padding: 10px;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  margin: 20px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
}

.wrapper-campaign header {
  height: 100px;
  margin-bottom: 20px;
  border-radius: 10px 10px 0px 0px;
  background: rgb(28, 134, 154);
  background: linear-gradient(180deg, rgba(28, 134, 154, 1) 0%, rgba(255, 255, 255, 1) 100%);
}

.wrapper-campaign h1 {
  text-align: center;
}

.wrapper-campaign header>h1 {
  font-size: 3rem;
  color: #fff;
}

.wrapper-clients-info {
  display: flex;
  justify-content: space-around;
}

.wrapper-no-clients {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper-no-clients i {
  font-size: 60px;
  color: red;
}

.client-info {
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  font-size: 1.5rem;
}

.current-client {
  width: 100%;
  border-right: solid 1px #cccccc;
}

.next-client {
  width: 40%;
  border-left: solid 1px #cccccc;
}

.redial-client {
  background: #ffeba1;
  background: linear-gradient(90deg, #ffeba1 0%, rgba(255, 255, 255, 1) 90%);
}

.no-clientes {
  width: 40%;
  align-items: center;
  justify-content: space-evenly;
}

.no-clientes i {
  font-size: 60px;
  color: red;
}

.wrapper-timer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper-dial-now {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 5px;
}

.wrapper-dial-now button {
  border-radius: 8px !important;
}

.clearfix:after,
.clearfix:before {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
  display: block;
}

.clock:before,
.count:after {
  content: "";
  position: absolute;
}

.clock-wrap {
  margin: auto;
  width: 225px;
  height: 225px;
  margin: 25px 0px;
  position: relative;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
}

.clock {
  top: 50%;
  left: 50%;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  position: absolute;
  margin-top: -90px;
  margin-left: -90px;
  background-color: #feeff4;
}

.clock:before {
  top: 50%;
  left: 50%;
  width: 120px;
  height: 120px;
  margin-top: -60px;
  margin-left: -60px;
  border-radius: inherit;
  background-color: #00b4d8;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15),
    0 0 3px rgba(255, 255, 255, 0.75) inset;
  /*border:1px solid rgba(255,255,255,.1);*/
}

.count {
  width: 100%;
  color: #fff;
  height: 100%;
  padding: 50px;
  font-size: 32px;
  font-weight: 500;
  line-height: 50px;
  position: absolute;
  text-align: center;
}

.count:after {
  width: 100%;
  display: block;
  font-size: 18px;
  font-weight: 300;
  line-height: 18px;
  text-align: center;
  position: relative;
}

.count.sec:after {
  content: "sec";
}

.count.min:after {
  content: "min";
}

.action {
  margin: auto;
  max-width: 200px;
}

.action .input {
  margin-top: 30px;
  position: relative;
}

.action .input-num {
  width: 100%;
  border: none;
  padding: 12px;
  border-radius: 60px;
}

.action .input-btn {
  top: 0;
  right: 0;
  color: #fff;
  border: none;
  border: none;
  padding: 12px;
  position: absolute;
  border-radius: 60px;
  background-color: #00b4d8;
  text-transform: uppercase;
}

.tbl {
  display: table;
  width: 100%;
}

.tbl .col {
  display: table-cell;
}
</style>